const TIMEOUT_MS = 10_000

let pendingRequest: Promise<void> = Promise.resolve()

export default function queueTrackingRequest(
  url: string,
  options: RequestInit
): Promise<void> {
  const send = () => {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), TIMEOUT_MS)
    return fetch(url, { ...options, signal: controller.signal }).finally(() =>
      clearTimeout(timeout)
    )
  }

  // Wait for each response's cookie before sending the next capture or privacy choice.
  pendingRequest = pendingRequest.then(send).then(
    () => {},
    () => {}
  )

  return pendingRequest
}
